export default __webpack_public_path__ + "static/media/data-report.35aced5e.svg";